import sessionStorageModule from '../utils/sessionStorageModule.js';
import cookieHandler from '../utils/cookieHandler.js';

export function getUserToken(){
  const userData = sessionStorageModule.getItem('gd-checkout-data');
  const eventiveToken = cookieHandler.getCookie('eventive-token');
  return userData?.token ?? eventiveToken ?? ''
}